import customFormatters from '@/filters/customFormatters'

/**
 *  ExploreWidgetCategorySimple script file
**/

export default {
  name: 'ExploreWidgetCategorySimple',
  mixins: [customFormatters],
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    max () {
      return Math.max(...this.data.map(d => d.value))
    },
    expandLabel () {
      return this.expanded ? 'Contraer' : 'Ver todos'
    },
    filteredList () {
      return this.expanded ? this.data : this.data.slice(0, this.limit)
    }
  },
  methods: {
    getBackgroundStyles (bar) {
      const percent = (100 * (bar.value / this.max)).toFixed(2)
      return `background: linear-gradient(90deg, var(--colorPrimaryTransparent) ${percent}%, var(--colorVeryLow) ${percent}%)`
    },
    toggle () {
      this.expanded = !this.expanded
    }
  }
}
